import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/5c64f483/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Number input`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/numberinput--default",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-number--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvnumberinput--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=number-input"
    }} mdxType="ComponentDemo">
  {`
    <NumberInput
      helperText="Optional helper text."
      id="tj-input"
      invalidText="Number is not valid"
      label="Number Input label"
      max={100}
      min={0}
      step={10}
      value={50}
    />
    `}
    </ComponentDemo>
    <h2>{`Mobile number input`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/numberinput--default",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-number--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvnumberinput--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=number-input"
    }} mdxType="ComponentDemo">
  {`
    <NumberInput
      isMobile
      helperText="Optional helper text."
      id="tj-input"
      invalidText="Number is not valid"
      label="Number Input label"
      max={100}
      min={0}
      step={10}
      value={50}
    />
    `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      